// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList,
  StatsGraph
}                         from '../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import { Spinner } from 'react-activity';
import styles      from './style';
import ReactTable from "react-table";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

class LeadsDetails extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    const search = props.location.search; // returns the URL query String
    const params = new URLSearchParams(search);
    console.log('cust_list.')
    console.log(props)
    this.state = {
      venue: props.statsTable.revenue_per_month.requested_venue_id,
      date: params.get('date'),
      report_no:params.get('report_no'),
      category:params.get('category'),
      customer_data:[],
      filtered_data:[],
      headers: [],
      search:'',
      loading: false,
      excel_data:[]
    };
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
    this.getCustomers(this.state.venue);
    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
        fetchStatsGraphDataIfNeeded
      }
    } = this.props;
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }

  getCustomers(venue) { 
    console.log('getCus..')
    console.log(venue)   
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=${this.state.report_no}&venue_id=${venue}&date=${this.state.date}&category=${this.state.category}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({customer_data:data.data,headers:data.headers,excel_data:data.excel_data})
           // alert("fix");
       }).catch(error => error);
  }

  handleSearch(event){
    const search = event.target.value.toLowerCase()
    const filter_result = this.state.data.filter((venue)=>{
      return venue.name.toLowerCase().indexOf(search) !== -1;
      }
      );
    this.setState({filtered_data:filter_result,search:search})
  }

  getTrProps = (state, rowInfo, instance) => {
      return {
        style: {
          background:'white',
          color:'black'
        }
      };
    };

  renderCutsomers(){
   
    var headers = []
    if(this.state.customer_data.length > 0){
      headers = Object.keys(this.state.customer_data[0])
    }
    console.log(headers)
    const headings = this.state.headers.map(function(element,index){
      var heading = {};
      heading["name"] = element;
      heading["accessor"] = index.toString();//For react-table
      heading["displayName"] = element;
      heading["Header"] = element; //For react-table
      heading["sortable"] = true;
      heading["inputFilterable"] = true;
      heading["visible"] = (element.indexOf("_hidden") == -1);
      heading["show"] = (element.indexOf("_hidden") == -1);
      heading["render"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;
      heading["Cell"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;// Custom cell components for react-table
      return heading;
    });
    headers = ['','Number','Customer','Package','Venue','Batch','Program','Attendance','End Date','Amount','Customer From','Life TIme Payment']

    return(
      <div>

      <div style={{float:'right',marginBottom:'1%'}}>
          
            <ReactHTMLTableToExcel
                        id="test-table-xls-button"
                        className="download-table-xls-button btn btn-primary"
                        table="table-to"
                        filename="Customer Details"
                        sheet="Customer Details"
                        buttonText="Download as XLS"/>
          
        </div>
      <div className='col-md-12 table_container1 table-responsive' style={{marginBottom:'2%'}}>
        <div className="heading heading2 left" style={{marginTop:'1%'}}>Customer Details</div> 
        { this.state.customer_data.length > 0 ?
          <ReactTable  
                      data={this.state.customer_data}  
                      columns={headings}  
                      defaultPageSize = {100}  
                      pageSizeOptions = {[100,200,500]} 
                      filterable={true}
                      showPagination={this.state.customer_data.length > 100}
                      showPaginationTop = {this.state.customer_data.length > 100}
                      style = {{background:'#ddd'}}
                      getTrProps = {this.getTrProps}
                      defaultFilterMethod = {(filter, row, column) => {
                        const id = filter.pivotId || filter.id
                        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
                      }}
                     
          >
            {
                //To show the record count on top  
                (state, makeTable, instance) => {

                  let recordsInfoText = "";

                  const { filtered, pageRows, pageSize, sortedData, page } = state;

                  if (sortedData && sortedData.length > 0) {
                    let isFiltered = filtered.length > 0;

                    let totalRecords = sortedData.length;

                    let recordsCountFrom = page * pageSize + 1;

                    let recordsCountTo = recordsCountFrom + pageRows.length - 1;

                    if (isFiltered){
                      recordsInfoText = `${totalRecords} filtered records`;
                    }
                    else {
                      recordsInfoText = `${totalRecords} records`;
                    }
                  } else {
                      recordsInfoText = "No records";
                    }
                  return (
                    <div className="main-grid" style={{background:'#ddd'}}>
                      <div className="above-table text-right">
                        <div className="col-sm-12 records-info">
                          <span className="">{recordsInfoText}</span>
                        </div>
                      </div>
                      {makeTable()}
                      
                    </div>

                  );
                }
              }
            </ReactTable>
          :
          this.state.headers.length > 0 ?
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> No Data Available</div>
            </div>
            :
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
            </div>
        }
      </div>
      <table id="table-to" style={{display:'none'}}>
        <tr> {headers.map((head)=><th>{head}</th>)}</tr>
          {this.state.excel_data.map((data)=>
                <tr>
                  { data.map((each,key)=>
                    <td >{each}</td>
                    )
                  }
                </tr>
                )}
          
      </table>
      </div>
      )
  }

  render() {
    

    const {
      statsTable,
      scoreCard,
      statsGraph,
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;
    
    console.log('props data',this.state.game_type)
    console.log('customer_data',this.state.customer_data)
    return(
      <div>
          
        <div>
         <div className="breadcrumps">
            <a href={'/#/dashboard/ActiveCustomer'} >
              <span>Dashboard</span>
            </a>
            <a href={'/#/dashboard/LeadsSummary'} >
              <span>Leads Summary</span>
            </a>
            <a onClick={()=>this.props.history.goBack()}>
              <span>Leads Daily List</span>
            </a> 
            <a>
              <span>Leads Detailed List</span>
            </a>
          </div>
          {this.renderCutsomers()}
        </div>
      </div>
    );
  }
}

export default LeadsDetails;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/LeadsDetails/LeadsDetails.js